import {
  WSButton,
  WSDateRangeSelect,
  WSDateRangeSelectOptions,
  WSDateRangeSelectRangeName,
  WSFlexBox,
  WSGrid,
  WSPage
} from "@wingspanhq/fe-component-library";
import { useState } from "react";
import { Route, useHistory } from "react-router-dom";
import { BrowserPageTitle } from "../../components/BrowserPageTitle/BrowserPageTitle";
import { OverlaySpinner } from "../../components/OverlaySpinner";
import { PaymentsStatusBanner } from "../components/PaymentsStatusBanner/PaymentsStatusBanner";
import { RecentClients } from "../components/RecentClients/RecentClients";
import { SummaryOutstanding } from "../components/SummaryOutstanding";
import { SummaryPaid } from "../components/SummaryPaid";
import { TableInvoicesOutstanding } from "../components/TableInvoicesOutstanding";
import { TableInvoicesScheduled } from "../components/TableInvoicesScheduled";
import { TableInvoicesUnsent } from "../components/TableInvoicesUnsent";
import { useVerificationUpgrade } from "../components/VerificationUpgrade/VerificationUpgrade";
import { InvoicesInvoiceDetails } from "./InvoicesInvoiceDetails";
import { InvoicesInvoiceTemplateDetails } from "./InvoicesInvoiceTemplateDetails";

export const InvoicesDashboard = () => {
  const history = useHistory();
  const {
    requestVerification,
    requestVerificationMeta,
    isBankingRequested,
    isCardPaymentsRequested
  } = useVerificationUpgrade();

  const [statsRange, setStatsRange] = useState(
    WSDateRangeSelectOptions.AllTime.range
  );
  const [statsRangeLabel, setStatsRangeLabel] = useState(
    WSDateRangeSelectOptions.AllTime.label
  );

  const createInvoiceHandler = async () => {
    try {
      if (!isBankingRequested || !isCardPaymentsRequested) {
        await requestVerification({
          banking: !isBankingRequested,
          cardPayments: !isCardPaymentsRequested
        });
      }
      history.push("/member/invoices/create", {
        backPath: "/member/invoices"
      });
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <>
      <Route
        path="/member/invoices/template/:invoiceTemplateId"
        component={InvoicesInvoiceTemplateDetails}
      />
      <Route
        path="/member/invoices/:invoiceId"
        component={InvoicesInvoiceDetails}
        exact
      />
      <BrowserPageTitle title="Invoices" />
      <WSPage
        title="Invoicing"
        primaryButtonComponent={props => (
          <WSButton
            name="createInvoice"
            onClick={createInvoiceHandler}
            {...props}
            size="L"
          >
            Create invoice
          </WSButton>
        )}
      >
        {requestVerificationMeta.isLoading && <OverlaySpinner zIndex={1000} />}
        <PaymentsStatusBanner mb="XL" />
        <WSFlexBox justify="space-between" wrap="nowrap">
          <WSDateRangeSelect
            mb="XL"
            onChange={(value, label) => {
              setStatsRange(value);
              setStatsRangeLabel(label);
            }}
            label={statsRangeLabel}
            value={statsRange}
            options={[
              WSDateRangeSelectRangeName.AllTime,
              WSDateRangeSelectRangeName.PastWeek,
              WSDateRangeSelectRangeName.PastMonth,
              WSDateRangeSelectRangeName.Past12Months,
              WSDateRangeSelectRangeName.Custom
            ]}
          />
          <WSButton.Link
            onClick={() => {
              history.push("/member/invoices/list");
            }}
          >
            All invoices
          </WSButton.Link>
        </WSFlexBox>

        <WSGrid>
          <WSGrid.Item span={{ s: "6" }}>
            <SummaryOutstanding dateRange={statsRange} />
          </WSGrid.Item>

          <WSGrid.Item span={{ s: "6" }}>
            <SummaryPaid dateRange={statsRange} />
          </WSGrid.Item>
        </WSGrid>

        <RecentClients />

        <TableInvoicesUnsent />

        <TableInvoicesOutstanding />

        <TableInvoicesScheduled />
      </WSPage>
    </>
  );
};
